import styled from 'styled-components'

export const Container = styled.section`
    float: left;
    width: 100%;
    position: relative;
    background-color: #0F1A2A;
    padding: 90px 60px 50px 60px;

    @media (max-width: 768px) {
        padding: 20px 20px 30px 20px;
    }
`

export const Texto = styled.span`
    float: left;
    width: 100%;
    color: #fff;
    font-size: 20px;
    line-height: 30px;
    font-weight: 600;
    margin: 0 0 15px 0;

    @media (max-width: 768px) {
        font-size: 16px;
        line-height: 28px;
        font-weight: 400;
        margin: 0 0 15px 0;
    }
`